import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Workflow} from '../../Model/Dto/Workflow/Workflow';
import {WorkflowItem} from '../../Model/Dto/Workflow/WorkflowItem';
import {WorkflowService} from '../../Services/Workflow/workflow.service';
import {LoginService} from '../../Services/login.service';
import {ItemType} from '../ItemType';
import {FtpServer} from 'app/Model/FtpServer';
import {Template} from 'app/Model/Catalog/Template';
import {FtpServerService} from 'app/Services/ftp/ftpServer.service';
import {TemplateService} from 'app/Services/template.service';
import {ExportParameter} from 'app/Model/exportParameter/ExportParameter';
import {ExportConfigurationService} from 'app/Services/exportConfiguration.service';
import {TranslateService} from '@ngx-translate/core';
import {ValidationMethod} from "../../Model/validation/ValidationMethod";
import {lastValueFrom} from "rxjs";
import {ValidationService} from "../../Services/Validation/validation.service";


@Component({
    selector: 'workflow-items',
    templateUrl: './workflow-items.component.html',
    styleUrl: './workflow-items.component.css',
    standalone: false
})
export class WorkflowItemsComponent {
  @Input() workflow: Workflow = null;
  @Output() workflowChange = new EventEmitter<any>;
  itemTypes: string[] = Object.values(ItemType);

  ftpServers: FtpServer[] = [];
  excelTemplates: Template[] = [];
  exportConfigs: ExportParameter[] = [];
  validationConfigs: ValidationMethod[] = [];
  workflows: Workflow[] = [];

  constructor(
    public workflowService: WorkflowService,
    public loginService: LoginService,
    public ftpServerService: FtpServerService,
    public templateService: TemplateService,
    public exportConfigurationService: ExportConfigurationService,
    public translate: TranslateService,
    public validationService: ValidationService,
  ) {
    this.onReorder = this.onReorder.bind(this);
    this.cellValueChanged = this.cellValueChanged.bind(this);

    this.ftpServerService.getAllServer().subscribe((ftpServer: FtpServer[]) => {
      this.ftpServers = ftpServer;
    });
    this.templateService.getTemplatesReturn().subscribe((templates: Template[]) => {
      this.excelTemplates = templates;
    });
    this.workflowService.getWorkflows(this.loginService.currentCustomer.id).then((workflows: Workflow[]) => {
      this.workflows = workflows;
    });


    this.exportConfigurationService
      .getAll(this.loginService.currentCustomer.id)
      .subscribe((configs: ExportParameter[]) => {
        this.exportConfigs = configs.filter((x) => !x.isUpdateFilter);
      });
    this.getValidationMethods();
  }

  async getValidationMethods(): Promise<void> {
    const validationMethods = await lastValueFrom(this.validationService.getValidationMethodsForCatalog());
    this.validationConfigs = validationMethods;
  }

  onReorder(e: any) {
    const data = e.component.option('dataSource');
    const fromIndex = e.fromIndex;
    const toIndex = e.toIndex;

    const fromItem = data[fromIndex];
    const toItem = data[toIndex];

    const tempOrder = fromItem.order;
    fromItem.order = toItem.order;
    toItem.order = tempOrder;

    data.sort((a, b) => a.order - b.order);
    e.component.option('dataSource', data);
    this.workflow.items = data;
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  macroParameterChangedChanged(macroParameter: { name: string, parameter: string }, item: WorkflowItem) {
    item.macroName = macroParameter.name;
    item.macroParameter = macroParameter.parameter;
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  cellValueChanged(e) {
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  removeItem(e: any) {
    const orderToDelete = e.data.order;
    this.workflow.items.forEach((item) => {
      if (item.order > orderToDelete) {
        item.order--;
      }
    });

    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
    this.workflow.items = [...this.workflow.items];
    this.workflowChange.emit(this.workflow);
  }


  changeItemType(item: WorkflowItem, e: { name: string; parameter: string }) {
    if (e) {
      item.macroName = e.name;
      item.macroParameter = e.parameter;
    }
    this.workflowService.updateOrCreateWorkflow(this.workflow, this.loginService.currentCustomer.id);
  }

  getMarcoDesc(m) {
    if (m && m.macroName) {
      return m.macroName + 'Short';
    }
    return 'Bitte auswählen ...';
  }
}
